import config from './config';

const pageError = config({
  /** Defaults for all sites and locales. */
  default: {
    /** Default settings for all languages. */
    default: {
      /** Whether or not to display the search box on the Not Found page. */
      showSearchBox: true
    }
  },
  'AHNU-US': { default: { showSearchBox: false } }
});

export default pageError;
